/**
 * @doc Editor
 */
export enum PanelType {
  Settings = 'settings',
  Layout = 'layout',
  Design = 'design',
  Upgrade = 'upgrade',
  Add = 'add',
}

export type PanelTypeStrings =
  | 'settings'
  | 'layout'
  | 'design'
  | 'upgrade'
  | 'add'

/**
 * @doc Editor
 */
export enum PanelResolveType {
  MAIN_ACTION = 'mainActionClicked',
  SECONDARY_ACTION = 'secActionClicked',
  CLOSE_ACTION = 'closeActionClicked',
}

/**
 * @doc Editor
 */
export enum PagesPanelTabType {
  PageInfo = 'page_info',
  Layout = 'layout',
  Permissions = 'permissions',
  SEO = 'seo',
  A11Y = 'a11y',
  SOCIAL_SHARE = 'social_share',
}

export type PagesPanelTabTypeStrings =
  | 'page_info'
  | 'layout'
  | 'permissions'
  | 'seo'
  | 'a11y'
  | 'social_share'

export enum customizeActions {
  Custom = 'Custom',
}

export type CustomizeActionsStrings = keyof typeof customizeActions
